
export const environment = {
    name: 'dev',
    production: false,
    servicesUrl: 'https://demo-api.mensapp.it/gestione-mense',
    recaptcha: {
        siteKey: '6Le5wUIhAAAAAE6gf7MCw3W_9oOLw_YuOH8iNHHI',
    },
    show: false,
    ticketsBackend: {
        url: 'https://comuni-demo.southengineering.it',
        username: 'admin1@2020',
        password: 'Fsh9mqt5',
    },
    keycloak: {
        authority: 'https://dev-keycloak-upgrade.southengineering.it/auth/realms/gestione-mense',
        clientId: 'mensa-client',
        tokenEndpoint: 'https://dev-keycloak-upgrade.southengineering.it/auth/realms/gestione-mense/protocol/openid-connect/token',
    },
};
